<div class="container" *ngIf="currentSong">
  <span *ngFor="let review of pendingReviews">
    <app-submit-review-widget *ngIf="!hasBeenReviewed(review.key)" [pendingReview]="review"></app-submit-review-widget>
  </span>
</div>
